import _ from 'lodash-es'

export const buildFormDataFrom = (formFields) => {
  const isBoolean = (value) => typeof value === 'boolean'
  const normalizeBoolean = (boolean) => Number(boolean)

  const formData = new FormData()

  for (const key in formFields) {
    let value = formFields[key]
    const objectKeyName = _.isObject(value) ? key : null
    const isFile = 'File' in window && formFields[key] instanceof File

    if (_.isArray(value)) {
      if (!value.length) {
        formData.append(`${key}[]`, [])
        continue
      }
    }

    if (isBoolean(value)) value = normalizeBoolean(value)

    if (objectKeyName && !isFile) {
      for (let objectKey in formFields[objectKeyName]) {
        let value = formFields[objectKeyName][objectKey]
        const key = convertCamelToSnakeCase(objectKeyName)
        const bracketsKey = convertCamelToSnakeCase(objectKey)

        if (isBoolean(value)) value = normalizeBoolean(value)

        formData.append(`${key}[${bracketsKey}]`, value)
      }
    } else {
      formData.append(key, value)
    }
  }

  return formData
}

export const removeNullableFieldsFrom = (formFields) => {
  return _(formFields).omitBy(_.isUndefined).omitBy(_.isNull).value()
}

export const removeEmptyArrays = (formFields) => {
  return _(formFields).pickBy(_.isArray).omitBy(_.isEmpty).value()
}

export const camelToSnake = (data, depth) => {
  if (_.isObject(data)) {
    if (typeof depth === 'undefined') {
      depth = 1
    }
    return _processKeys(data, _snakelize, depth)
  } else {
    return _snakelize(data)
  }
}

export const snakeToCamel = (data, depth) => {
  if (_.isObject(data)) {
    if (typeof depth === 'undefined') {
      depth = 1
    }
    return _processKeys(data, _.camelCase, depth)
  } else {
    return _.camelCase(data)
  }
}

export const convertToKebabCase = (string) => {
  return string.replace(/\s+/g, '-').toLowerCase()
}

export const convertCamelToSnakeCase = (str) =>
  str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)

export const toCamelCase = (str) => {
  return str
    .split('-')
    .map(function (word, index) {
      // If it is the first word make sure to lowercase all the chars.
      // eslint-disable-next-line eqeqeq
      if (index === 0) {
        return word.toLowerCase()
      }
      // If it is not the first word only upper case the first char and lowercase the rest.
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    .join('')
}
/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export function isObject(item) {
  return item && typeof item === 'object' && !Array.isArray(item)
}

/**
 * Deep merge two objects.
 * @param target
 * @param ...sources
 */
export function mergeDeep(target, ...sources) {
  if (!sources.length) return target
  const source = sources.shift()

  if (isObject(target) && isObject(source)) {
    for (const key in source) {
      if (isObject(source[key])) {
        if (!target[key]) Object.assign(target, { [key]: {} })
        mergeDeep(target[key], source[key])
      } else {
        Object.assign(target, { [key]: source[key] })
      }
    }
  }

  return mergeDeep(target, ...sources)
}

// camelize/snakelize keys of an object
// @param {number} depth to which level of keys should it process
function _processKeys(obj, processer, depth) {
  if (depth === 0 || !_.isObject(obj)) {
    return obj
  }

  const result = {}
  const keys = Object.keys(obj)

  for (let i = 0; i < keys.length; i++) {
    result[processer(keys[i])] = _processKeys(
      obj[keys[i]],
      processer,
      depth - 1
    )
  }

  return result
}

// snakelize a string formed in underscore
function _snakelize(key) {
  const separator = '_'
  const split = /(?=[A-Z0-9])/

  return key.split(split).join(separator).toLowerCase()
}

/**
 * Source to image object
 * @param {string} src - The source
 * @param {string} fileName - Filename
 * @param {string} mimeType - Mimetype
 * @return {File}
 */

function srcToFile(src, fileName, mimeType) {
  return fetch(src)
    .then((res) => res.arrayBuffer())
    .then((buffer) => new File([buffer], fileName, { type: mimeType }))
}

export const toSpaceCase = (str) => {
  return (
    str
      .replace(/[-_]/g, ' ')
      /*
       * insert a space between lower & upper
       * HttpRequest => Http Request
       */
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      /*
       * space before last upper in a sequence followed by lower
       * XMLHttp => XML Http
       */
      .replace(/\b([A-Z]+)([A-Z])([a-z])/, '$1 $2$3')
      // uppercase the first character
      .replace(/^./, (str) => str.toUpperCase())
      .replace(/\s+/g, ' ')
  )
}

export const redirectTo = (href) => {
  const $body = document.querySelector('body')
  const $a = document.createElement('a')
  $a.href = href
  $a.setAttribute('target', '_blank')

  $body.appendChild($a)

  $a.click()
}

export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
export const pluralize = (count, single, plural) =>
  `${count !== 1 ? plural || single + 's' : single}`
